// AlertsOverview.tsx

import { Box, Typography } from "@mui/material";
import SeverityPieChart, { SeverityPieData } from "./TrendCharts/SeverityPieChart";
import AlertsTableWrapper from "./AlertsTableWrapper";

interface AlertsOverviewProps {
  data: SeverityPieData[];
  isLoading: boolean;
  onSliceClick?: (source: string) => void;
}

const AlertsOverview = ({
  data,
  isLoading,
  onSliceClick,
}: AlertsOverviewProps) => {
  return (
    <Box>
      <Typography
        variant="h4"
        sx={{ fontWeight: 500, color: "primary.main" }}
      >
        All Open Alerts
      </Typography>

      <Typography
        variant="h6"
        sx={{ mb: 3, color: "primary.main" }}
      >
        No Date Range
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 4,
          alignItems: "flex-start",
        }}
      >
        <Box sx={{ flex: 1, width: '-webkit-fill-available' }}>
          <SeverityPieChart
            data={data}
            isLoading={isLoading}
            onSliceClick={onSliceClick}
          />
        </Box>

        {/* <Box
          sx={{
            width: 1100,
            flexShrink: 0,
          }}
        >
          <AlertsTableWrapper />
        </Box> */}
      </Box>
    </Box>
  );
};

export default AlertsOverview;